import styled from 'styled-components'
import {ButtonStyled} from '../../../../../components/button/button.styled'
export const Button = styled(ButtonStyled)`
    justify-content: space-between;
    align-items: center;
    min-width: 110px;
`
